module.exports = __webpack_public_path__ + "img/UAE-Portrait-arabic.ac51ef41.jpg";